<form [formGroup]="signUpForm" (ngSubmit)="onSubmit()">
  <div class="form-group">
    <label for="firstName">{{ 'signUpPage.signUpForm.labels.firstName' | translate }}</label>
    <input
      type="text"
      formControlName="firstName"
      [placeholder]="'signUpPage.signUpForm.placeholders.firstName' | translate"
      [ngClass]="{
        'is-invalid': hasError('firstName'),
      }"
    />
    @if (hasError('firstName')) {
      <div class="error-message" [ngClass]="{ 'is-invalid': hasError('firstName') }">
        @if (hasError('firstName', 'required')) {
          <div>{{ getErrorMessage('firstName', 'required') }}</div>
        }
        @if (hasError('firstName', 'minLength')) {
          <div>{{ getErrorMessage('firstName', 'minLength') }}</div>
        }
        @if (hasError('firstName', 'maxLength')) {
          <div>{{ getErrorMessage('firstName', 'maxLength') }}</div>
        }
        @if (hasError('firstName', 'pattern')) {
          <div>{{ getErrorMessage('firstName', 'pattern') }}</div>
        }
      </div>
    }
  </div>

  <div class="form-group">
    <label for="lastName">{{ 'signUpPage.signUpForm.labels.lastName' | translate }}</label>
    <input
      type="text"
      formControlName="lastName"
      [placeholder]="'signUpPage.signUpForm.placeholders.lastName' | translate"
      [ngClass]="{ 'is-invalid': hasError('lastName') }"
    />
    @if (hasError('lastName')) {
      <div class="error-message" [ngClass]="{ 'is-invalid': hasError('lastName') }">
        @if (hasError('lastName', 'required')) {
          <div>{{ getErrorMessage('lastName', 'required') }}</div>
        }
        @if (hasError('lastName', 'minLength')) {
          <div>{{ getErrorMessage('lastName', 'minLength') }}</div>
        }
        @if (hasError('lastName', 'maxLength')) {
          <div>{{ getErrorMessage('lastName', 'maxLength') }}</div>
        }
        @if (hasError('lastName', 'pattern')) {
          <div>{{ getErrorMessage('lastName', 'pattern') }}</div>
        }
      </div>
    }
  </div>

  <div class="form-group">
    <label for="email">{{ 'signUpPage.signUpForm.labels.email' | translate }}</label>
    <input
      type="text"
      inputmode="email"
      formControlName="email"
      [placeholder]="'signUpPage.signUpForm.placeholders.email' | translate"
      [ngClass]="{ 'is-invalid': hasError('email') }"
    />
    @if (hasError('email')) {
      <div class="error-message" [ngClass]="{ 'is-invalid': hasError('email') }">
        @if (hasError('email', 'required')) {
          <div>{{ getErrorMessage('email', 'required') }}</div>
        }
        @if (hasError('email', 'pattern')) {
          <div>{{ getErrorMessage('email', 'pattern') }}</div>
        }
      </div>
    }
  </div>

  <div class="form-group">
    <label for="password">{{ 'signUpPage.signUpForm.labels.password' | translate }}</label>
    <div class="password-container">
      <input
        [type]="isPasswordVisible ? inputType.TEXT : inputType.PASSWORD"
        formControlName="password"
        [placeholder]="'signUpPage.signUpForm.placeholders.password' | translate"
        [ngClass]="{ 'is-invalid': hasError('password') }"
      />
      <div class="icon-wrapper" role="button" tabindex="0" (click)="togglePasswordVisibility()">
        <app-icon [icon]="isPasswordVisible ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE" />
      </div>
    </div>
    @if (hasError('password')) {
      <div class="error-message" [ngClass]="{ 'is-invalid': hasError('password') }">
        @if (hasError('password', 'required')) {
          <div>{{ getErrorMessage('password', 'required') }}</div>
        }
        @if (hasError('password', 'minLength')) {
          <div>{{ getErrorMessage('password', 'minLength') }}</div>
        }
        @if (hasError('password', 'maxLength')) {
          <div>{{ getErrorMessage('password', 'maxLength') }}</div>
        }
        @if (hasError('password', 'noSpaces')) {
          <div>{{ getErrorMessage('password', 'noSpaces') }}</div>
        }
        @if (hasError('password', 'pattern')) {
          <div>{{ getErrorMessage('password', 'pattern') }}</div>
        }
      </div>
    }
    @if (
      signUpForm.controls['password'].invalid &&
      signUpForm.controls['password'].dirty &&
      signUpForm.controls['password'].value
    ) {
      <app-password-hints [password]="signUpForm.controls['password'].value" />
    }
  </div>

  <div class="form-group">
    <label for="confirmPassword">
      {{ 'signUpPage.signUpForm.labels.confirmPassword' | translate }}
    </label>
    <div class="password-container">
      <input
        id="confirmPassword"
        [type]="isConfirmPasswordVisible ? inputType.TEXT : inputType.PASSWORD"
        formControlName="confirmPassword"
        [placeholder]="'signUpPage.signUpForm.placeholders.confirmPassword' | translate"
        [ngClass]="{ 'is-invalid': hasError('confirmPassword') }"
      />
      <div
        class="icon-wrapper"
        role="button"
        tabindex="0"
        (click)="toggleConfirmPasswordVisibility()"
      >
        <app-icon
          [icon]="isConfirmPasswordVisible ? iconName.PASSWORD_EYE : iconName.PASSWORD_EYE_HIDE"
        />
      </div>
    </div>
    @if (hasError('confirmPassword')) {
      <div class="error-message" [ngClass]="{ 'is-invalid': hasError('confirmPassword') }">
        @if (hasError('confirmPassword', 'required')) {
          <div>{{ getErrorMessage('confirmPassword', 'required') }}</div>
        }
        @if (hasError('confirmPassword', 'missMatch')) {
          <div>{{ getErrorMessage('confirmPassword', 'missMatch') }}</div>
        }
      </div>
    }
  </div>

  <div class="form-group checkbox-group">
    <div class="checkbox-container">
      <input
        type="checkbox"
        formControlName="termsAccepted"
        [ngClass]="{
          'is-invalid': hasError('termsAccepted'),
        }"
      />
      <label
        for="termsAccepted"
        [ngClass]="{
          'is-invalid': hasError('termsAccepted'),
        }"
      >
        {{ 'signUpPage.signUpForm.labels.termsAccepted' | translate }}
        <button class="open-modal" (click)="onTermsAcceptModal()">
          {{ 'signUpPage.signUpForm.labels.termsAcceptedRef' | translate }}
        </button>
      </label>
    </div>
    @if (hasError('termsAccepted')) {
      <div class="error-message">
        @if (hasError('termsAccepted', 'required')) {
          <div>{{ getErrorMessage('termsAccepted', 'required') }}</div>
        }
      </div>
    }
  </div>

  <div class="form-group checkbox-group">
    <div class="checkbox-container">
      <input type="checkbox" formControlName="newsletter" />
      <label for="newsletter">
        {{ 'signUpPage.signUpForm.labels.newsletter' | translate }}
      </label>
    </div>
  </div>

  <button
    type="submit"
    class="option create-account-btn"
    [ngClass]="{ disabled: signUpForm.invalid }"
    [disabled]="signUpForm.invalid"
  >
    {{ 'signUpPage.signUpForm.button' | translate }}
  </button>

  <div class="divider">
    <span>{{ 'signUpPage.signUpForm.or' | translate }}</span>
  </div>

  <app-social-login />

  <p class="form-signin">
    {{ 'signUpPage.signUpForm.signInCheck' | translate }}
    <a [routerLink]="appRoutes.LOGIN">
      {{ 'signUpPage.signUpForm.signInLink' | translate }}
    </a>
  </p>
</form>
